import { useEffect } from 'react';
import { connect } from 'react-redux';

import { isAssigned, triggerAssignment } from 'actions/ab';
import { HYDRA_EDITORIAL_SEARCH_PLACEMENTS } from 'constants/hydraTests';
import TopBannerAd from 'components/search/TopBannerAd';
import InlineBannerAd from 'components/search/InlineBannerAd';
import SearchInlineHero from 'components/search/SearchInlineHero';
import SearchTopHero from 'components/search/SearchTopHero';

const componentMap = {
  inlineBannerAd: InlineBannerAd,
  topBannerAd: TopBannerAd,
  searchInlineHero: SearchInlineHero,
  searchTopHero: SearchTopHero
};

export const SearchSlot = ({ slotDetails, hydraSearchInlineEditorials, hydraSearchTopEditorials, hydraSearchBothEditorials, triggerAssignment, ...props }) => {
  const name = slotDetails?.componentName;

  useEffect(() => {
    if (name === 'searchInlineHero' || name === 'searchTopHero') {
      triggerAssignment(HYDRA_EDITORIAL_SEARCH_PLACEMENTS);
    }
  }, [name, triggerAssignment]);

  if (name === 'searchInlineHero' && !(hydraSearchInlineEditorials || hydraSearchBothEditorials)) {
    return null;
  }

  if (name === 'searchTopHero' && !(hydraSearchTopEditorials || hydraSearchBothEditorials)) {
    return null;
  }

  const Component = componentMap[name];
  return Component ? <Component slotDetails={slotDetails} {...props} /> : null;
};

const mapStateToProps = state => ({
  hydraSearchInlineEditorials: isAssigned(HYDRA_EDITORIAL_SEARCH_PLACEMENTS, 1, state),
  hydraSearchTopEditorials: isAssigned(HYDRA_EDITORIAL_SEARCH_PLACEMENTS, 2, state),
  hydraSearchBothEditorials: isAssigned(HYDRA_EDITORIAL_SEARCH_PLACEMENTS, 3, state)
});

export default connect(mapStateToProps, { triggerAssignment })(SearchSlot);
